import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import { Lan, LanOutlined } from '@mui/icons-material';
export const IconElement = memo(forwardRef((props, ref) => {
    const { icon_type, ...rest } = props;
    switch (icon_type) {
        case 'ethernet':
            return _jsx(ResponsiveIcon, { Icon: Lan, ...rest, ref: ref });
        case 'ethernet-no':
        default:
            return _jsx(ResponsiveIcon, { Icon: LanOutlined, ...rest, ref: ref });
    }
}));
IconElement.displayName = 'EthernetIconElement';
